import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9871526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-dropdown" }
const _hoisted_2 = { class: "filter-dropdown__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-next btn__icon" }, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-dropdown__divider" }, null, -1 /* HOISTED */))

import { ref, type Ref, computed, onUpdated } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterDropdown',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
};



const collapsed = ref(true);

const isOnTop = ref(true);

const isOnBottom = ref(false);

const contentElement: Ref<HTMLElement | null> = ref(null);

const scrollHeight = computed(() => {
  return contentElement.value?.scrollHeight ?? 0;
})

function onScroll() {
  const top = contentElement.value?.scrollTop ?? 0;
  const clientHeight = contentElement.value?.clientHeight ?? 0;
  isOnTop.value = top === 0;
  isOnBottom.value = scrollHeight.value - clientHeight - top === 0;
}

const height = 400;

const scrollHide = ref(true);

onUpdated(() => {
  scrollHide.value = scrollHeight.value > height;
});

const contentStyle = computed(() => {
  const obj = collapsed.value ? {
    maxHeight: `0px`,
    marginTop: `0`,
  } : {};
  return {
    maxHeight: `${height}px`,
    ...obj
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "filter-dropdown__head",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (collapsed.value = !collapsed.value))
    }, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */),
      _createElementVNode("button", {
        class: _normalizeClass(["btn filter-dropdown__button", !collapsed.value ? 'filter-dropdown__button_active' : ''])
      }, _hoisted_4, 2 /* CLASS */)
    ]),
    _createElementVNode("section", {
      class: "filter-dropdown__content",
      style: _normalizeStyle(_unref(contentStyle))
    }, [
      _hoisted_5,
      (scrollHide.value)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            class: _normalizeClass(["icon-next icon-next__top", { active: !isOnTop.value }]),
            icon: "fa-solid fa-angles-up"
          }, null, 8 /* PROPS */, ["class"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: "filter-dropdown__content-wrap",
        ref_key: "contentElement",
        ref: contentElement,
        onScroll: onScroll
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 544 /* HYDRATE_EVENTS, NEED_PATCH */),
      (scrollHide.value)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 1,
            class: _normalizeClass(["icon-next icon-next__bottom", { active: !isOnBottom.value }]),
            icon: "fa-solid fa-angles-down"
          }, null, 8 /* PROPS */, ["class"]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */)
  ]))
}
}

})